// extracted by mini-css-extract-plugin
module.exports = {"image":"business-resource-image-carousel_image__Nos02"};